module.exports = __webpack_public_path__ + "img/pay.e0002920.svg";